export const useStyles = (theme) => ({
  root: {
    padding: 20,
    minHeight: "50vh",
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  paper: {
    padding: 10,
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down(600)]: {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: 5,
    },
  },
  coverImageStyle: {
    width: 200,
    height: 260,
    [theme.breakpoints.down(600)]: {
      width: 250,
      height: 350,
    },
  },
  textfieldRoot: {
    display: "flex",
    [theme.breakpoints.down(600)]: { flexDirection: "column" },
  },
  inputRoot: {
    height: 40,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
    backgroundColor: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  iconStyle: {
    color: "#0a1f3a",
    "&:hover": {
      cursor: "pointer",
    },
  },
});
